import EventBus from '@/event-bus';
import deleteDialogMixin from '@/mixins/deleteDialog';

export default {
  mixins: [deleteDialogMixin],
  props: ['items'],
  methods: {
    detail(id) {
      this.$router.push(`/${this.showUrl}/${id}/show`);
    },
    editItem(id) {
      EventBus.$emit('editItem', id);
    },
    editItemWithEvent($event, id) {
      if (!$event || ($event && $event.target.className !== 'btn__content')) {
        EventBus.$emit('editItem', id);
      }
    },
    changeStatus(id, currentStatus, route = null) {
      let status = currentStatus === 'Inactivo' || currentStatus === 'Pendiente' ? 'Activo' : 'activo';
      if (currentStatus === 'activo' || currentStatus === 'Activo') {
        status = currentStatus === 'Activo' ? 'Inactivo' : 'inactivo';
      }
      this.axios.patch(`${route || this.route}/${id}`, { status }).then(() => {
        EventBus.$emit('update');
      }).catch(() => {});
    },
    deleteItem(id, name) {
      EventBus.$emit('deleteItem', id, name);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/dataTableList.js